import { Component, EventEmitter, Input, Output } from "@angular/core"

@Component({
    selector: "app-pagination",
    templateUrl: "./pagination.component.html",
    styleUrls: ["./pagination.component.scss"],
    standalone: false,
})
/*
 * When using `simplePagination` it will remove the first, last, next and prev buttons, it will only contain the numbers
 * if the `pagesToShow` is bigger then `count` it will enable force enable the arrows even if `simplePagination`is on
 */
export class PaginationComponent {
    @Input() public page: number
    @Input() public count: number
    @Input() public perPage: number
    @Input() public pagesToShow: number
    @Input() public loading: boolean
    @Input() public simplePagination: boolean = false

    @Output() public goPrev = new EventEmitter<boolean>()
    @Output() public goNext = new EventEmitter<boolean>()
    @Output() public goFirst = new EventEmitter<boolean>()
    @Output() public goLast = new EventEmitter<boolean>()
    @Output() public goPage = new EventEmitter<number>()

    public onPage(page: number): void {
        this.goPage.emit(page)
    }

    public onPrev(): void {
        this.goPrev.emit(true)
    }

    public onNext(): void {
        this.goNext.emit(true)
    }

    public onFirst(): void {
        this.goFirst.emit(true)
    }

    public onLast(): void {
        this.goLast.emit(true)
    }

    public totalPages(): number {
        return Math.ceil(this.count / this.perPage) || 0
    }

    public lastPage(): boolean {
        return this.perPage * this.page >= this.count
    }

    public getPages(): number[] {
        const count = Math.ceil(this.count / this.perPage)
        const page = this.page || 1
        const pagesToShow = this.pagesToShow || 7
        const pages: number[] = []
        pages.push(page)
        const times = pagesToShow - 1
        for (let i = 0; i < times; i++) {
            if (pages.length < pagesToShow) {
                if (Math.min.apply(null, pages) > 1) {
                    pages.push(Math.min.apply(null, pages) - 1)
                }
            }
            if (pages.length < pagesToShow) {
                if (Math.max.apply(null, pages) < count) {
                    pages.push(Math.max.apply(null, pages) + 1)
                }
            }
        }
        pages.sort((a, b) => a - b)
        return pages
    }
}
